import React, { useState, useEffect } from 'react';
import { FaCheckCircle, FaClock, FaCalendarAlt, FaGift, FaEnvelope, FaHeadset } from 'react-icons/fa';
import { TbArrowBigDownLinesFilled } from "react-icons/tb";
import { motion } from 'framer-motion';

const CountDown = ({thankYouPage}) => {

    const [timer, setTimer] = useState('');
    const [nextSession, setNextSession] = useState('');
    const [canJoin, setCanJoin] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error] = useState(null);

    const [gradientClass, setGradientClass] = useState('bg-gradient-to-b from-blue-600 to-indigo-700');
    const [bgColor, setBgColor] = useState('bg-blue-600');
    const [bgShadow, setBgShadow] = useState('bg-blue-50');
    const [ctaColor, setCtaColor] = useState('bg-gradient-to-r from-blue-500 to-purple-500');
    const [textColor, setTextColor] = useState('text-blue-600');
    const [textShadow, setTextShadow] = useState('text-blue-100');
    const [hoverColor, setHoverColor] = useState('bg-blue-700');

    useEffect(() => {
        const updateTime = () => {
          const now = new Date();
    
          const startsIn = localStorage.getItem('time');
          const nextWebinar = new Date(now.getTime());
          nextWebinar.setMinutes(Math.ceil(nextWebinar.getMinutes() / startsIn) * startsIn, 0, 0);
      
          const diff = Math.max(0, nextWebinar - now);
          const minutes = Math.floor(diff / (1000 * 60));
          const seconds = Math.floor((diff % (1000 * 60)) / 1000);
      
          const hours = Math.floor(minutes / 60);
          const remMinutes = minutes % 60;
      
          const formattedHours = hours.toString().padStart(2, '0');
          const formattedMinutes = remMinutes.toString().padStart(2, '0');
          const formattedSeconds = seconds.toString().padStart(2, '0');
      
          let sessionHour = nextWebinar.getHours();
          const sessionMinute = nextWebinar.getMinutes().toString().padStart(2, '0');
          const sessionPeriod = sessionHour >= 12 ? 'PM' : 'AM';
          sessionHour = sessionHour % 12 || 12;
      
          setTimer(`${formattedHours} hr ${formattedMinutes} min ${formattedSeconds} sec`);
          setNextSession(`${sessionHour}:${sessionMinute} ${sessionPeriod}`);
      
          if (diff <= 0) {
            setCanJoin(true);
          }
        };
    
        const interval = setInterval(updateTime, 1000);
        return () => clearInterval(interval);
      }, []);
    
      useEffect(() => {
        if (canJoin && thankYouPage.redirectPage) {
          window.location.href = thankYouPage.redirectPage; 
        }
      }, [canJoin, thankYouPage.redirectPage]);


  return (
    <>
      <div className={`${gradientClass} rounded-2xl shadow-xl overflow-hidden`}>
        <div className="p-6 text-center text-white">
        <h2 className="text-2xl font-bold mb-2">{thankYouPage.ticketText}</h2>
        {/* <p className="opacity-90 mb-6">Access details will be emailed to you</p> */}
        
        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 mb-6">
            <motion.div
            animate={{ y: [0, 5, 0] }}
            transition={{ repeat: Infinity, duration: 2 }}
            >
            <TbArrowBigDownLinesFilled className="text-yellow-300 text-4xl mx-auto mb-3" />
            </motion.div>
            <h3 className="text-xl font-semibold mb-3">
            {thankYouPage.webinarHeadline}
            </h3>

            {/* Countdown Timer */}
            <div className="flex justify-center space-x-3 mb-5">
            {timer.split(' ').filter((_, i) => i % 2 === 0).map((time, index) => (
                <motion.div
                key={index}
                initial={{ scale: 0.8 }}
                animate={{ scale: 1 }}
                transition={{
                    repeat: Infinity,
                    repeatType: "reverse",
                    duration: 1.5,
                    delay: index * 0.2
                }}
                className="bg-white/20 backdrop-blur-sm w-14 h-14 flex flex-col items-center justify-center rounded-lg"
                >
                <span className="text-xs font-light">{timer.split(' ')[index*2 + 1]}</span>
                <span className="font-bold text-lg">{time}</span>
                </motion.div>
            ))}
            </div>

            <div className="flex items-center justify-center text-sm mb-4">
            <FaClock className="mr-2" />
            <span>
                {thankYouPage.webinarStartsText} <strong>{nextSession}</strong>
            </span>
            </div>
        </div>

        <motion.button
            whileHover={canJoin ? { scale: 1.02 } : {}}
            whileTap={canJoin ? { scale: 0.98 } : {}}
            className={`w-full py-4 px-4 bg-gradient-to-r from-yellow-400 to-yellow-500 text-gray-900 text-lg font-bold rounded-lg shadow-lg transition-all duration-300 ${
            !canJoin ? 'opacity-70 cursor-not-allowed' : 'hover:from-yellow-500 hover:to-yellow-600'
            }`}
            disabled={!canJoin}
        >
            {thankYouPage.webinarButtonText}
        </motion.button>

        {/* <div className="mt-6 text-sm opacity-80">
            <p>Can't make it? We'll send you the recording.</p>
        </div> */}
        </div>
    </div>
    </>
  )
}

export default CountDown
